import React, { useEffect, useState } from 'react';
import "./../home/index.css";
import { postData } from "../common/utils";
import DataTable from 'datatables.net-dt';
import 'datatables.net-responsive-dt';
import loading from "./../../assets/images/loading-new.gif";
import 'jquery/dist/jquery.min.js';
import { useAlert } from "react-alert";
import { ArrowLongLeftIcon } from '@heroicons/react/24/solid';
import { Link } from "react-router-dom";

//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery';

const RewardRequest = () => {
    const alert = useAlert();
    const [results, setResults] = useState([]);
    const [totalRequest, setTotalRequest] = useState(0);
    const [pending, setPending] = useState(0);
    const [approved, setApproved] = useState(0);

    useEffect(() => {

        fetch(process.env.REACT_APP_API_URL + "api/rewards/requests")
            .then((response) => response.json())
            .then((data) => {
                if (data.issuccessful == true) {
                    setResults(data.rewards);

                }
            });

    }, [])

    useEffect(() => {
        fetch(process.env.REACT_APP_API_URL + "api/rewards/requestsummary")
            .then((response) => response.json())
            .then((data) => {

                if (data.issuccessful == true) {
                    setTotalRequest(data.totalrequest);
                    setPending(data.pendingrequest);
                    setApproved(data.approved);
                }
            });
    }, [])

    $(document).ready(function () {
        setTimeout(function () {
            $('#myTable').DataTable();
        }, 1000);
    });


    // $('.issue-btn').on('click', function () {
    //     $("#loader").css("display", "block");
    //     var id = $(this).data('id');
    //     var email = $(this).data('email');
    //     var name = $(this).data('name');
    //     var gc = $(this).data('gc');
    //     //console.log("trans_id", id);
    //     var data = {
    //         TransID: id,
    //         useremail: email,
    //         username: name,
    //         giftcard: gc,
    //     };
    //     //console.log('daaaaaaaaaaaaaaaaaaaaaaata', data);
    //     postData(
    //         process.env.REACT_APP_API_URL + "api/rewards/updateRewardRequest",
    //         data
    //     ).then((data) => {
    //         if (data.issuccessful == true) {
    //             $(`#status-${id}`).html(data.message);
    //             $("#loader").css("display", "none");
    //         }
    //     })
    // })


    const issueMail = (id, email, name, gc) => {
        $("#loader").css("display", "block");
        var data = {
            TransID: id,
            useremail: email,
            username: name,
            giftcard: gc,
        };
        //console.log('daaaaaaaaaaaaaaaaaaaaaaata', data);
        postData(
            process.env.REACT_APP_API_URL + "api/rewards/updateRewardRequest",
            data
        ).then((data) => {
            if (data.issuccessful == true) {
                $(`#status-${id}`).html(data.message);
                $("#loader").css("display", "none");
                alert.success("Gift card mail sent!!");
            } else {
                alert.error("Something went wrong.");
            }
        })
    }

    const downloadExcel = () => {
        $("#loader").css("display", "none");
        var from = document.getElementById("fromdate").value;
        var to = document.getElementById("todate").value;
        if (from !== '' && to !== '') {

            window.location.href = process.env.REACT_APP_API_URL + "api/rewards/downloadExcel/" + from + "/" + to;

        } else {
            alert.error("Please select FROM and TO date.");

        }

    }



    return (

        <div style={{ position: "relative" }} className="rewardRequest">

            <Link to="/admin/manage-rewards" className='admin-header' style={{ marginBottom: '40px' }}>
                <ArrowLongLeftIcon className="" style={{ width: '30px' }} />
                <p style={{ marginBottom: '0' }} >Open Requests</p>
            </Link>

            <div id='loader' style={{ display: "none", position: "fixed", top: "50%", left: "55%", transform: "translate(-50%,-50%)", zIndex: "1" }}>
                <img src={loading} alt="loading..." />
            </div>
            <link rel="stylesheet" href="https://cdn.datatables.net/1.13.3/css/jquery.dataTables.css"></link>
            <div style={{ marginTop: "40px", backgroundColor: "white", padding: "20px", borderRadius: "8px" }}>
                <p style={{ marginBottom: "10px", fontFamily: "Poppins", fontWeight: 600, fontSize: "1.1rem" }} >Reward Summary</p>
                <div style={{ display: 'flex', gap: '15px', justifyContent: "space-between" }}>
                    <div className='requestSummaryCard rewards-count' style={{ display: "block" }}>
                        <span>{totalRequest}</span>
                        <p>Total Requests</p>
                    </div>

                    <div className='requestSummaryCard rewards-count' style={{ display: "block" }}>
                        <span>{approved}</span>
                        <p>Gift Card Issued</p>
                    </div>

                    <div className='requestSummaryCard rewards-count' style={{ display: "block" }}>
                        <span>{pending}</span>
                        <p>Pending Requests</p>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: "40px", backgroundColor: "white", padding: "20px", borderRadius: "8px" }}>
                <p style={{ marginBottom: "10px", fontFamily: "Poppins", fontWeight: 600, fontSize: "1.1rem" }} >Export Reward Requests</p>
                <div id="excel-export">

                    <div id="date-div">
                        <div>
                            <label htmlFor='fromdate'>From</label><br />
                            <input type='date' id='fromdate' name='fromdate' required />
                        </div>

                        <div>
                            <label htmlFor='todate'>To</label><br />
                            <input type='date' id='todate' name='todate' required />
                        </div>
                    </div>

                    <div id="export-div">
                        <button className='issue-btn-export' onClick={downloadExcel}>Export!</button>
                    </div>


                </div>
            </div>

            <div style={{ marginTop: "40px", backgroundColor: "white", padding: "20px", borderRadius: "8px", marginBottom: "40px" }}>
                <p style={{ marginBottom: "25px", fontFamily: "Poppins", fontWeight: 600, fontSize: "1.1rem" }} >Reward Requests</p>
                <table id="myTable" className="display table table-hover table-bordered" data-page-length='10'>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Amount</th>
                            <th>Gift Card</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {results.map((data, index) => {

                            return (
                                <tr key={index}>
                                    <td>{data.created_date}</td>
                                    <td>{data.UserName}</td>
                                    <td>{data.UserEmail}</td>
                                    <td>₹ {data.RewardAmount}</td>
                                    <td>{data.GiftCard}</td>

                                    {data.IsSuccessful == 1 ? (
                                        <td>Issued</td>
                                    ) : (
                                        <td id={"status-" + data.TransactionID}><button className='issue-btn' onClick={() => issueMail(data.TransactionID, data.UserEmail, data.UserName, data.GiftCard)} data-id={data.TransactionID} data-email={data.UserEmail} data-name={data.UserName} data-gc={data.GiftCard}>Issue</button></td>
                                    )}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            {/* componentDidMount() {
                $('#myTable').DataTable()
            } */}


        </div>
    )
};

export default RewardRequest